import request from './request'

export function smsLogin(data) {
  return request.post('/User/smsLogin', data)
}

export function sendSmsCode(data) {
  return request.post('/User/sendSmsCode', data)
}

export function getUserInfo() {
  return request.get('/User/info')
}
